import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MerchantsService } from '../../core/services/merchants.service';

@Component({
  selector: 'app-unsubscribe-page',
  templateUrl: './unsubscribe-page.component.html',
  styleUrls: ['./unsubscribe-page.component.scss']
})
export class UnsubscribePageComponent implements OnInit {

  public errorMsg;
  public loading;
  public successMsg;

  public clientId;
  public clientCode;

  constructor(private merchantsService: MerchantsService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.clientId = this.activatedRoute.snapshot.params.clientId;
    this.clientCode = this.activatedRoute.snapshot.params.clientCode;
  }

  confirmUnsubscribe() {
    this.loading = true;
    this.merchantsService.unsubscribeClient(this.clientId, this.clientCode).subscribe(res => {
      this.successMsg = this.translate.instant('LANDING.unsubscribe.successMessage');
      this.loading = false;
    }, (err) => {
      this.errorMsg = err.errMsg;
      this.loading = false;
    });
  }
}
